import React from 'react'
import { fontWeight, spacing } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import { useDomainMessages } from 'domains/account-management/utils/domain/intl'
import { Button } from 'gin-and-tonic/common/button/Button'

const StyledContainer = styled.div({
  paddingTop: spacing.X64,
  textAlign: 'center',
  maxWidth: 500,
  margin: '0 auto',

  '.header': {
    fontWeight: fontWeight.SEMIBOLD,
    margin: spacing.X20,
  },

  '.content': {
    marginBottom: spacing.X20,
  },
})

interface Props {
  onRetry: () => void
}

export const accountUpdateGetAccountErrorTestId = 'account-update-get-account-error'

export const AccountUpdateGetAccountError: React.FunctionComponent<Props> = ({ onRetry }) => {
  const messages = useDomainMessages({
    header: 'accountManagementDomain.update.getAccount.error.header',
    content: 'accountManagementDomain.update.getAccount.error.content',
    retryLabel: 'accountManagementDomain.update.getAccount.error.retry',
  })

  return (
    <StyledContainer data-testid={accountUpdateGetAccountErrorTestId}>
      <div className="header">{messages.header}</div>
      <div className="content">{messages.content}</div>
      <div>
        <Button onClick={onRetry}>{messages.retryLabel}</Button>
      </div>
    </StyledContainer>
  )
}
